module.exports = __webpack_public_path__ + "f188b1db2667aedb18ed1feea4281016.fbx";